// CJ - Intended for create group and rename group.
// Modifies behavior for rename if a group is passed as input to the dialog.
// renameGroup function needs more work if a synchronouse response is expected
// from the dialog with the renamed group uid, etc.

import { Component, Inject, OnInit } from "@angular/core";
import { GroupData } from "../../model/groupdata.model";
import { ToasterService } from "../../service/toaster.service";

import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from "@angular/material/dialog";

import { GroupService } from "../../service/group.service";
import { MatButtonModule } from "@angular/material/button";
import { FormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { CdkDrag, CdkDragHandle } from "@angular/cdk/drag-drop";

export const ERR_NONE = 0;
export const ERR_CREATE_GROUP = 101;
export const ERR_RENAME_GROUP = 102;

export interface GroupInterface {
  uid?: string;
  name?: string;
  owner?: string;
  created_at?: number;
}

export interface GroupNameInput {
  group?: GroupData;
  groupUID?: string;
  groupName?: string;
  groupOwner?: string;
  groupList?: GroupData[];
}

export interface GroupNameOutput {
  group?: GroupData;
  groupUID?: string;
  groupName?: string;
  groupOwner?: string;
  groupCreated?: number;
}

@Component({
    selector: "app-group-name",
    templateUrl: "./group-name.dialog.html",
    styleUrls: ["./group-name.dialog.css"],
    standalone: true,
    imports: [
        MatDialogModule,
        CdkDrag,
        CdkDragHandle,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        MatButtonModule,
    ],
})
export class GroupNameDialogComponent {
  dialogTitle: string;
  dialogMessage: string;
  dialogBtnTitle: string;

  resp: any;
  group: GroupData;
  groupName: string;
  oldGroupName: string;
  groupUID: any;
  groupOwner: any;
  groupCreated: any;
  groupList: any;
  rename: boolean;
  errCode = 0;

  constructor(
    private groupsvc: GroupService,
    private toast: ToasterService,
    private dialogRef: MatDialogRef<GroupNameDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
  ) {
    if (data) {
      console.log("group-name groupUID=", data.groupUID);
      console.log("group-name groupName=", data.groupName);
      console.log("group-name group=", data.group);
      if (data.groupUID) {
        this.groupUID = data.groupUID;
      }
      if (data.groupName) {
        this.groupName = data.groupName;
      } else {
        this.groupName = "";
      }
      if (data.groups) {
        this.groupList = data.groups;
      }
      if (data.groupList) {
        this.groupList = data.groupList;
      }
      if (data.rename) {
        this.rename = data.rename;
      } else {
        this.rename = false;
      }
      if (this.rename === true) {
        // check for a groupUID, group or groupName input data
        if (!this.groupUID) {
          if (this.group) {
            this.groupUID = this.group.uid;
          } else if (this.groupName) {
            this.group = this.groupList.filter(
              (g) => g.name === this.groupName,
            );
            this.groupUID = this.group.uid;
          } else {
            this.toast.pop(
              "error",
              "Rename Group",
              "Must pass groupUID, group or groupName for rename",
            );
            console.log("group-name: rename bad params");
            this.close();
          }
        }
      }
    } // if (data)
    if (this.rename === true) {
      this.oldGroupName = this.groupName;
      this.dialogTitle = "Rename Group " + this.groupName;
      this.dialogMessage = "Enter the new name for group " + this.groupName;
      this.dialogBtnTitle = "Rename";
    } else {
      this.dialogTitle = "Create Group ";
      this.dialogMessage = "Enter the new group name";
      this.dialogBtnTitle = "Create";
    }
    this.errCode = ERR_NONE;
    // console.log('group dialog rename=', data.rename);
  }

  ngOnInit() {
    console.log("grp name dialog=", this.groupName ?? "");
  }

  close() {
    this.dialogRef.close();
  }

  async save() {
    let x = null;
    let y = null;
    // Check non blank input
    if (this.groupName === null || this.groupName === "") {
      this.dialogMessage =
        "Error: Group Name must not be blank! Enter the Group Name.";
      return;
    }
    if (this.rename === false) {
      try {
        x = await this.groupsvc.addGroup(this.groupName);
        this.toast.pop(
          "success",
          "Create Group",
          `Created new group (${this.groupName}) successfully.`,
        );
        console.log("groupname: add x =", x);
        this.group = x;
        this.groupUID = x.uid;
        this.groupName = x.name;
        this.groupOwner = x.owner;
      } catch (error) {
        this.toast.pop(
          "error",
          "Create Group",
          `Failed to create group (${this.groupName})`,
        );
        console.log("group-name: add group error=", error);
        return;
      }
    } else {
      try {
        console.log("group-name renaming uid = ", this.groupUID);
        console.log("group-name renaming to = ", this.groupName);
        y = await this.groupsvc.renameGroupPromise(
          this.groupUID,
          this.groupName,
        );
        this.toast.pop(
          "success",
          "Rename Group",
          `Group ${this.oldGroupName} has been renamed to ${this.groupName}`,
        );
        console.log("rename returned=", y);
        this.group = y;
      } catch (err) {
        this.toast.pop(
          "error",
          "Rename Failed",
          `Failed to rename group from ${this.oldGroupName} to ${this.groupName}`,
        );
        console.log("group-name: rename group error=", err);
        return;
      }
    }

    const output: GroupNameOutput = {
      group: this.group,
      groupUID: this.groupUID,
      groupName: this.groupName,
      groupOwner: this.groupOwner,
    };
    // console.log('group-name: output=', output);
    this.dialogRef.close(output);
  }
}
